/* eslint-disable */
import axios from 'axios';
import config from '../../../config';
import { bus } from '@/main';
import AssociazioneEntity from '@/pages/anagrafica/associazioni/AssociazioneEntity';
import StoricoIscrizioneAssociatoEntity from '@/pages/anagrafica/associati/StoricoIscrizioneAssociatoEntity';
import { base64StringToBlob } from 'blob-util';

const state = {
  image: [],
  associato: [],
  associatoAsync: [],
  associati: [],
  attestati: [],
  associatiFiltrate: [],
  albo: [],
  alboFiltrati: [],
  istruttori: [],
  giudici: [],
  dettagliAssociazione: [],
  storicoIscrizione: [],
  storicoIscrizioni: [],
};

const getters = {
  getDettagliAssociazione: () => state.dettagliAssociazione,
  getAssociati: () => state.associatiFiltrate,
  getAlbo: () => state.alboFiltrati,
  getIstruttori: () => state.istruttori,
  getGiudici: () => state.giudici,
  getAttestati: () => state.attestati,
  getAssociato: () => state.associato,
  getAssociatoAsync: () => state.associatoAsync,
  getImage: () => state.image,
  getStoricoIscrizione: () => state.storicoIscrizione,
  getStoricoIscrizioni: () => state.storicoIscrizioni,
};

const actions = {
  loadAssociatoAsync({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/associati/' + id)
        .then(function (response) {
          commit('setAssociato', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },

  loadAssociato({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/associati/' + idItem)
      .then(function (response) {
        commit('setAssociato', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setAssociato', null);
      });
  },

  loadAssociatoByStorico({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/associati/storico/' + idItem)
      .then(function (response) {
        commit('setAssociato', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setAssociato', null);
      });
  },

  loadStoricoIscrizione({ commit }, data) {
    axios
      .get(config.ROOT_API + '/api/associati/' + data.idAssociato + '/storicoIscrizioni/' + data.idStorico)
      .then(function (response) {
        commit('setStoricoIscrizione', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setStoricoIscrizione', null);
      });
  },
  loadStoricoIscrizioni({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/associati/' + idItem + '/storicoIscrizioni/')
      .then(function (response) {
        commit('setStoricoIscrizioni', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setStoricoIscrizioni', null);
      });
  },

  loadAttestati({ commit }, idItem) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/partecipazioniview/attestati/' + idItem)
        .then(function (response) {
          commit('setAttestati', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
  createAssociato({ dispatch, commit }, newItem) {
    axios
      .post(config.ROOT_API + '/api/associati', newItem)
      .then(function (response) {
        commit('addAssociato');
        dispatch('loadAssociati');
      })
      .catch((err) => {
        console.error(err);
      });
  },
  updateAssociato({ dispatch, commit }, editItem) {
    // rimuovo l'immagine dall'oggetto associato perchè è gestita con un servizio apposito
    delete editItem.image;
    axios
      .patch(config.ROOT_API + '/api/associati', editItem)
      .then(function (response) {
        commit('editAssociato');
        dispatch('loadAssociati');
      })
      .catch((err) => {
        console.error(err);
      });
  },
  updateStoricoAssociato({ dispatch, commit }, editItem) {
    // rimuovo l'immagine dall'oggetto associato perchè è gestita con un servizio apposito
    delete editItem.image;
    axios
      .patch(config.ROOT_API + '/api/associati', editItem)
      .then(function (response) {
        commit('editAssociato');
        dispatch('loadAssociatiDaRinnovare');
      })
      .catch((err) => {
        console.error(err);
      });
  },
  updateStoricoIscrizione({ dispatch, commit }, editItem) {
    axios
      .post(config.ROOT_API + '/api/associati/' + editItem.AssociatoId + '/storicoIscrizioni/' + editItem.id, editItem)
      .then(function (response) {
        commit('editStoricoIscrizione');
        dispatch('loadStoricoIscrizione');
      })
      .catch((err) => {
        console.error(err);
      });
  },
  creaUserAssociato({ dispatch, commit }, idItem) {
    // generazione utente per associato
    axios
      .patch(config.ROOT_API + '/api/associati/' + idItem + '/createUser')
      .then(function (response) {
        commit('editAssociato');
        dispatch('loadAssociati');
      })
      .catch((err) => {
        console.error(err);
      });
  },

  resetPasswordAssociato({ dispatch, commit }, idItem) {
    // reset utente per associato
    axios
      .patch(config.ROOT_API + '/api/associati/' + idItem + '/createUser')
      .then(function (response) {
        commit('editAssociato');
        dispatch('loadAssociati');
      })
      .catch((err) => {
        console.error(err);
      });
  },

  deleteIndirizzoAssociato({ dispatch, commit }, editItem) {
    axios
      .put(config.ROOT_API + '/api/associati', editItem)
      .then(function (response) {
        commit('removeIndirizzoAssociato');
        dispatch('loadAssociati');
      })
      .catch((err) => {
        console.error(err);
      });
  },
  deleteAssociatoAsync({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(config.ROOT_API + '/api/associati/' + item.id)
        .then(function (response) {
          commit('removeAssociato', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
  deleteAssociato({ dispatch, commit }, item) {
    axios
      .delete(config.ROOT_API + '/api/associati/' + item.id)
      .then(function (response) {
        commit('removeAssociato', response.data);
        setTimeout(function () {
          dispatch('loadAssociati');
        }, 500);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  deleteAssociati({ dispatch, commit }, item) {
    axios
      .post(config.ROOT_API + '/api/associazioni/' + item.associazioneId + '/removeassociati', item.associatiId)
      .then(function (response) {
        commit('removeAssociati', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },

  deleteStoricoIscrizioniAsync({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.ROOT_API + '/api/associati/rinnovi/remove', data)
        .then(function (response) {
          dispatch('loadAssociatiDaRinnovare').then(() => {
            commit('removeStoricoIscrizioni', response.data);
            resolve(response.data);
          });
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },

  deleteStoricoIscrizioni({ dispatch, commit }, data) {
    axios
      .post(config.ROOT_API + '/api/associati/rinnovi/remove', data)
      .then(function (response) {
        commit('removeStoricoIscrizioni', response.data);
        setTimeout(function () {
          dispatch('loadAssociatiDaRinnovare');
        }, 500);
      })
      .catch((err) => {
        console.error(err);
      });
  },

  deleteStoricoIscrizioneAsync({ dispatch, commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(config.ROOT_API + '/api/associati/rinnovi/remove/' + item)
        .then(function (response) {
          dispatch('loadAssociatiDaRinnovare').then(() => {
            commit('removeStoricoIscrizione', response.data);
            resolve(response.data);
          });
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
  deleteStoricoIscrizione({ dispatch, commit }, item) {
    axios
      .delete(config.ROOT_API + '/api/associati/rinnovi/remove/' + item)
      .then(function (response) {
        commit('removeStoricoIscrizione', response.data);
        setTimeout(function () {
          dispatch('loadAssociatiDaRinnovare');
        }, 500);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  stampaPassAssociatiAsync({ dispatch, commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.ROOT_API + '/api/associazioni/' + item.id + '/arcopasses/', item.data)
        .then(function (response) {
          commit('downloadCsainPass', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          console.error(err).then(() => {
            dispatch('loadAssociati');
          });
          reject(err);
        });
    });
  },
  stampaPassAssociati({ dispatch, commit }, item) {
    axios
      .post(config.ROOT_API + '/api/associazioni/' + item.id + '/arcopasses/', item.data)
      .then(function (response) {
        setTimeout(function () {
          commit('downloadCsainPass', response.data);
        }, 500);
      })
      .catch((err) => {
        console.error(err);
        setTimeout(function () {
          dispatch('loadAssociati');
        }, 500);
      });
  },

  stampaAttestatoAsync({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/associati/' + itemId + '/attestato')
        .then(function (response) {
          commit('stampaAttestato', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },

  stampaAttestatoFormativo({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/partecipazioniview/attestato/' + itemId)
        .then(function (response) {
          commit('stampaAttestatoFormativo', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },

  stampaAttestato({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/associati/' + itemId + '/attestato')
      .then(function (response) {
        setTimeout(function () {
          commit('stampaAttestato', response.data);
        }, 500);
      })
      .catch((err) => {
        console.error(err);
      });
  },

  loadAssociati({ commit }, associazioneID) {
    if (associazioneID) {
      axios
        .get(config.ROOT_API + '/api/associati/associazione/' + associazioneID)
        .then(function (response) {
          commit('setAssociati', response.data);
        })
        .catch((err) => {
          console.error(err);
          commit('setAssociati', null);
        });
    } else {
      axios
        .get(config.ROOT_API + '/api/associati')
        .then(function (response) {
          commit('setAssociati', response.data);
        })
        .catch((err) => {
          console.error(err);
          commit('setAssociati', null);
        });
    }
  },

  loadAssociatiDaRinnovare({ commit }) {
    axios
      .get(config.ROOT_API + '/api/associati/rinnovi/')
      .then(function (response) {
        commit('setAssociati', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setAssociati', null);
      });
  },

  loadTesseratiDaRinnovare({ commit }) {
    axios
      .get(config.ROOT_API + '/api/associati/tesserati/')
      .then(function (response) {
        commit('setAssociati', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setAssociati', null);
      });
  },

  exportAssociatiDaRinnovare({ commit }) {
    axios
      .get(config.ROOT_API + '/api/associati/rinnovi/download')
      .then(function (response) {
        commit('downloadRinnovi', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },

  exportAssociatiDuplicati({ commit }) {
    axios
      .get(config.ROOT_API + '/api/associati/exportDuplicati')
      .then(function (response) {
        commit('downloadDuplicati', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },

  uploadAssociatiDaRinnovareAsync({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.ROOT_API + '/api/associati/rinnovi/upload', data.uploadData)
        .then(function (response) {
          dispatch('loadTesseratiDaRinnovare').then(() => {
            commit('uploadRinnovi', response.data);
            resolve(response.data);
          });
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },

  async uploadAssociatiDaRinnovare({ commit, dispatch }, data) {
    axios
      .post(config.ROOT_API + '/api/associati/rinnovi/upload', data.uploadData)
      .then(function (response) {
        commit('uploadRinnovi', response.data);
        setTimeout(function () {
          dispatch('loadTesseratiDaRinnovare');
        }, 500);
      })
      .catch((err) => {
        console.error(err);
        commit('importRinnovi', null);
      });
  },

  uploadTesseratiDaRinnovareAsync({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.ROOT_API + '/api/associati/tesserati/upload', data.uploadData)
        .then(function (response) {
          dispatch('loadAssociatiDaRinnovare').then(() => {
            commit('uploadRinnovi', response.data);
            resolve(response.data);
          });
        })
        .catch((err) => {
          console.error(err).then(() => {
            dispatch('importRinnovi');
          });
          reject(err);
        });
    });
  },

  async uploadTesseratiDaRinnovare({ commit, dispatch }, data) {
    axios
      .post(config.ROOT_API + '/api/associati/tesserati/upload', data.uploadData)
      .then(function (response) {
        commit('uploadRinnovi', response.data);
        setTimeout(function () {
          dispatch('loadAssociatiDaRinnovare');
        }, 500);
      })
      .catch((err) => {
        console.error(err);
        commit('importRinnovi', null);
      });
  },

  iscriviPerCorrenteAsync({ commit, dispatch }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.ROOT_API + '/api/associati/rinnovi/corrente/' + item)
        .then(function (response) {
          dispatch('loadAssociatiDaRinnovare').then(() => {
            commit('iscriviCorrente', response.data);
            resolve(response.data);
          });
        })
        .catch((err) => {
          console.error(err).then(() => {
            dispatch('loadAssociatiDaRinnovare');
          });
          reject(err);
        });
    });
  },

  async iscriviPerCorrente({ commit, dispatch }, item) {
    axios
      .post(config.ROOT_API + '/api/associati/rinnovi/corrente/' + item)
      .then(function (response) {
        commit('iscriviCorrente', response.data);
        setTimeout(function () {
          dispatch('loadAssociatiDaRinnovare');
        }, 500);
      })
      .catch((err) => {
        console.error(err);
        commit('loadAssociatiDaRinnovare', null);
      });
  },

  loadAlbo({ commit }) {
    axios
      .get(config.ROOT_API + '/api/albo')
      .then(function (response) {
        commit('setAlbo', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setAlbo', null);
      });
  },

  loadIstruttoriAssociazione({ commit }, associazioneID) {
    axios
      .get(config.ROOT_API + '/api/albo/?filter={ "where": { "Istruttore": "1" , "AssociazioneId":"' + associazioneID + '" }} ')
      .then(function (response) {
        commit('setIstruttori', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setIstruttori', null);
      });
  },

  loadIstruttori({ commit }) {
    axios
      .get(config.ROOT_API + '/api/albo/?filter={ "where": { "Istruttore": "1"}} ')
      .then(function (response) {
        commit('setIstruttori', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setIstruttori', null);
      });
  },

  loadGiudici({ commit }) {
    axios
      .get(config.ROOT_API + '/api/albo/?filter={ "where": { "Tecnico": "1"}} ')
      .then(function (response) {
        commit('setGiudici', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setGiudici', null);
      });
  },

  loadDettagliAssociazione({ commit }, associazioneID) {
    axios
      .get(config.ROOT_API + '/api/associazioni/' + associazioneID)
      .then(function (response) {
        commit('setAssociazione', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setAssociazione', null);
      });
  },
  loadImage({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/associati/' + itemId + '/image')
      .then(function (response) {
        commit('setImage', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setImage', null);
      });
  },
  updateProfileImage({ commit }, data) {
    axios
      .post(config.ROOT_API + '/api/associati/' + data.id + '/image', data.uploadData)
      .then(function (response) {
        commit('editImage', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('editImage', null);
      });
  },
  filterCol({ dispatch, commit }, obj) {
    // filtra i risultati su una specifica colonna
    state.associatiFiltrate = state.associati.filter((a) => {
      if (typeof a[obj.col] !== 'string') {
        // filtro per stato (attivo / non attivo / tutti)
        if (obj.val == 'all') {
          return true;
        } else {
          // eslint-disable-next-line
          return a[obj.col] == obj.val;
        }
      } else {
        return a[obj.col].toLowerCase().indexOf(obj.val.toLowerCase()) > -1;
      }
    });
  },
  search({ commit }, val) {
    // filtra i risultati su tutte le colonne
    if (val) {
      state.associatiFiltrate = state.associati.filter((a) => {
        return JSON.stringify(a).toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }
  },

  exportAssociatiXLS({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/associati/' + itemId + '/export')
      .then(function (response) {
        commit('exportAssociatiXLS', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  exportSagittaXLS({ commit }, completo) {
    axios
      .get(config.ROOT_API + '/api/associati/' + completo + '/sagitta')
      .then(function (response) {
        commit('exportSagittaXLS', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  loadCsainPass({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/associati/' + itemId + '/arcopass')
      .then(function (response) {
        commit('downloadCsainPass', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  loadCampionatoPass({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/associati/' + itemId + '/arcopassCampionato')
      .then(function (response) {
        commit('downloadCsainPass', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
};

const mutations = {
  addAssociato(mdl) {
    window.getApp.$emit('ASSOCIATO_CREATA');
    bus.$emit('associatoDialog', false);
  },
  editAssociato(mdl) {
    window.getApp.$emit('ASSOCIATO_MODIFICATA');
    bus.$emit('associatoDialog', false);
  },
  editStoricoIscrizione(mdl) {
    window.getApp.$emit('STORICO_MODIFICATO');
  },
  removeIndirizzoAssociato(mdl) {
    window.getApp.$emit('INDIRIZZO_ASSOCIATO_RIMOSSO');
  },
  setAssociato(mdl, associato) {
    state.associato = associato;
  },
  setAssociati(mdl, associati) {
    state.associati = associati;
    state.associatiFiltrate = associati;
  },
  setStoricoIscrizione(mdl, storicoIscrizione) {
    state.storicoIscrizione = new StoricoIscrizioneAssociatoEntity(storicoIscrizione);
  },
  setStoricoIscrizioni(mdl, storicoIscrizioni) {
    state.storicoIscrizioni = storicoIscrizioni;
  },
  setAlbo(mdl, albo) {
    state.albo = albo;
    state.alboFiltrati = albo;
  },
  setIstruttori(mdl, istruttori) {
    state.istruttori = istruttori;
  },
  setGiudici(mdl, giudici) {
    state.giudici = giudici;
  },
  setAttestati(mdl, attestati) {
    state.attestati = attestati;
  },
  setAssociazione(mdl, associazione) {
    state.dettagliAssociazione = new AssociazioneEntity(associazione);
  },
  setImage(mdl, image) {
    state.image = image;
  },
  editImage(mdl) {
    window.getApp.$emit('IMMAGINE_AGGIORNATA');
  },
  iscriviCorrente(mdl) {
    window.getApp.$emit('ISCRIVI_CORRENTE');
  },
  removeAssociato(mdl, item) {
    window.getApp.$emit('ASSOCIATO_RIMOSSO');
    bus.$emit('deleteAssociati', true);
  },
  removeAssociati(mdl, item) {
    window.getApp.$emit('ASSOCIATI_RIMOSSI');
    bus.$emit('deleteAssociati', true);
  },
  removeStoricoIscrizione(mdl, item) {
    window.getApp.$emit('STORICO_RIMOSSO');
    bus.$emit('deleteStoricoIscrizioni', true);
  },
  removeStoricoIscrizioni(mdl, item) {
    window.getApp.$emit('STORICI_RIMOSSI');
    bus.$emit('deleteStoricoIscrizioni', true);
  },

  rinnovaAssociati(mdl, item) {
    window.getApp.$emit('ASSOCIATI_RICHIESTA_RINNOVO');
  },
  annullaAssociati(mdl, item) {
    window.getApp.$emit('ASSOCIATI_RICHIESTA_RIMOZIONE');
  },

  uploadRinnovi(mdl, message) {
    window.getApp.$emit('RINNOVI PROCESSATI');
    if (message != '') {
      bus.$emit('erroreRinnovo', message);
    } else {
      bus.$emit('rinnovoUploaded', true);
    }
  },

  exportAssociatiXLS(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  exportSagittaXLS(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  exportRinnoviIscrittiXLS(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  downloadCsainPass(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/pdf',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  downloadRinnovi(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  downloadDuplicati(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  stampaAttestato(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/pdf',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
